import { API_BASE } from './config'
export const API_URL = API_BASE

export const SUBJECTS = {
  1: [
    { code: 'AEL101', name: 'AEL 101' },
    { code: 'AEL103', name: 'AEL 103' },
    { code: 'AEL105', name: 'AEL 105' },
    { code: 'AEL109', name: 'AEL 109' },
    { code: 'AEL110', name: 'AEL 110' },
  ],
  2: [
    { code: 'AEL209', name: 'AEL 209' },
    { code: 'AEL211', name: 'AEL 211' },
  ],
  3: [
    { code: 'AEL301', name: 'AEL 301' },
    { code: 'AEL302', name: 'AEL 302' },
    { code: 'AEL307', name: 'AEL 307' },
    { code: 'AEL308', name: 'AEL 308' },
    { code: 'AEL330', name: 'AEL 330' },
  ],
  4: [
    { code: 'AEL416', name: 'AEL 416' },
    { code: 'AEL422', name: 'AEL 422' },
  ],
};